import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { checkMot } from '../../ressources/functionJS/checkMot';
import S from './InterfaceClient.module.scss';
import OngletsClient from './Tabs/OngletsClient';

const InterfaceClient = ({ project_id, montrerMenu }) => {
  const [flagProjectIdInProjectsList, setFlagProjectIdInProjectsList] =
    useState(false);

  const projects_list = useSelector((state) => state.authentifie.projects_list);

  useEffect(() => {
    // Recherche si le projet est dans la liste des projets de l'utilisateur
    for (let project of projects_list) {
      if (parseInt(project_id) === project.project_id) {
        setFlagProjectIdInProjectsList(true);
        break;
      }
    }
  }, [project_id, projects_list]);

  let affiche;
  if (flagProjectIdInProjectsList) {
    affiche = (
      <div className={[S.ConteneurProjet].join(' ')}>
        <OngletsClient key={project_id} montrerMenu={montrerMenu} inProjectContext />
      </div>
    );
  } else {
    affiche = <p>{checkMot('vous_n_avez_pas_acces_projet')}</p>;
  }

  return affiche;
};

export default InterfaceClient;
